import { Injectable, signal } from '@angular/core';
import { STORAGE_KEYS } from '@pa-angular/pa-fe-boilerplate';

export type AnalyticsConsentValue = 'accepted' | 'denied';

@Injectable({
  providedIn: 'root',
})
export class ConsentStorageService {
  private readonly CONSENT_KEY = STORAGE_KEYS.ANALYTICS_CONSENT;

  /**
   * Reactive consent state signal
   * Notifies all components when consent changes
   */
  readonly consent = signal<AnalyticsConsentValue | null>(
    this.getConsentFromStorage(),
  );

  private getConsentFromStorage(): AnalyticsConsentValue | null {
    try {
      return localStorage.getItem(
        this.CONSENT_KEY,
      ) as AnalyticsConsentValue | null;
    } catch {
      return null;
    }
  }

  getConsent(): AnalyticsConsentValue | null {
    return this.consent();
  }

  setConsent(value: AnalyticsConsentValue): void {
    try {
      localStorage.setItem(this.CONSENT_KEY, value);
      this.consent.set(value);
    } catch (error) {
      console.warn('[ConsentStorageService] Failed to store consent:', error);
    }
  }

  clearConsent(): void {
    try {
      localStorage.removeItem(this.CONSENT_KEY);
      this.consent.set(null);
    } catch {
      // Ignore storage errors
    }
  }
}
